import { Attachment, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutDriverImage extends Layout {
    attachmentDriverImage: Attachment;
    sourceDriverImage: DataSource;
}
